import React from 'react';
import ReactDOM from 'react-dom';
import '~/utils/initLocale';
import {setLanguage, updateToc} from '~/utils/tools';
import {LANDING_VERSION} from '~/utils/constant';
import Header from '~/components/sphinxTheme/Header';
import Footer from '~/components/sphinxTheme/Footer';
import Banner from '~/components/sphinxTheme/Banner';
import '~/components/sphinxTheme/styleConfig';
import '~/components/sphinxTheme/comment';
import * as serviceWorker from '~/serviceWorker';
import '../assets/icons/portal/style.css';
import './index.less';

updateToc();
const link = document.createElement('link');
link.setAttribute('rel', 'stylesheet');
const time = `${new Date().getFullYear()}-${new Date().getMonth()}-${new Date().getDate()}-${new Date().getHours()}`;
link.setAttribute('href', `/docs/static/css/themeCustom.css?${time}`);
link.setAttribute('type', 'text/css');
const head = document.getElementsByTagName('head')[0];
if (head) {
  head.insertAdjacentElement('beforeend', link);
}

const {
  language = '',
  currentVersion = ''
} = window.sphinxEnosThemeHeader || {};
if (language === 'en' || language === 'en_us' || language === 'en_US' || language === 'EN_US') {
  setLanguage('en');
} else {
  setLanguage('zh_CN');
}

const linkElements = Array.from(document.head.querySelectorAll('link'));
const canonicalLink = linkElements.find((linkElement) => linkElement.getAttribute('rel') === 'canonical');
if (canonicalLink) {
  canonicalLink.setAttribute('href', `https://support.enos-iot.com${window.location.pathname}`);
}

const rst = document.querySelector('.enos-doc-content-body .rst-content');
const banner = document.createElement('div');
const bannerId = document.createAttribute('id');
bannerId.value = 'banner-wrapper';
banner.setAttributeNode(bannerId);

const tocTreeHelper = () => {
  window.onload = () => {
    const tocTreeList = document.querySelectorAll('.enos-doc .enos-doc-toc .toctree-l1 a');
    if (tocTreeList) {
      tocTreeList.forEach((aDom) => {
        if (aDom?.nextElementSibling?.getBoundingClientRect()?.height > 0) {
          if (aDom.children[0]) {
            aDom.children[0].addEventListener('click', (e) => {
              e.preventDefault();
              e.stopPropagation();
            });
          }
        }
      });
    }
  };
};

tocTreeHelper();

if (rst) {
  rst.insertAdjacentElement('afterbegin', banner);
  ReactDOM.render(<Banner />, banner);
}

if (document.getElementById('header') && (LANDING_VERSION.concat(['dev']).includes(currentVersion))) {
  ReactDOM.render(<Header />, document.getElementById('header'));
}

if (document.getElementById('footer')) {
  ReactDOM.render(<Footer />, document.getElementById('footer'));
}
// homepage is /docs/
// ReactDOM.render(<Footer />, document.getElementById('footer'));
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
